import { render, staticRenderFns } from "./CodeEditor.vue?vue&type=template&id=24d67ab6&scoped=true"
import script from "./CodeEditor.vue?vue&type=script&lang=js"
export * from "./CodeEditor.vue?vue&type=script&lang=js"
import style0 from "./CodeEditor.vue?vue&type=style&index=0&id=24d67ab6&prod&scoped=true&lang=css"
import style1 from "./CodeEditor.vue?vue&type=style&index=1&id=24d67ab6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d67ab6",
  null
  
)

export default component.exports